import Component_EnvironmentTexture_1126362630754f724c11f3cf6db5c4a8 from "../../../../content/examples/basic/assign-to/EnvironmentTexture";
import Devtool_EnvironmentTexture_1126362630754f724c11f3cf6db5c4a8 from "!!@devtool/loader!../../../../content/examples/basic/assign-to/EnvironmentTexture";
import Component_AssignTo_1126362630754f724c11f3cf6db5c4a8 from "../../../../content/examples/basic/assign-to/AssignTo";
import Devtool_AssignTo_1126362630754f724c11f3cf6db5c4a8 from "!!@devtool/loader!../../../../content/examples/basic/assign-to/AssignTo";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_EnvironmentTexture_1126362630754f724c11f3cf6db5c4a8,
  Devtool_EnvironmentTexture_1126362630754f724c11f3cf6db5c4a8,
  Component_AssignTo_1126362630754f724c11f3cf6db5c4a8,
  Devtool_AssignTo_1126362630754f724c11f3cf6db5c4a8,
  DevTool,
  React
};